export default {
  monthlyCostPosition: 'center',
  leadPosition: 'left',
  leadPadding: '0.6rem 0 0 0',
  valueFontSize: '1.85rem',
  monthlyCostLabelFontSize: '1rem',
  labelColor: 'var(--base-brown)',
};
